/**
 * Dynamically updates all favicon and apple-touch-icon link tags in document.head
 * with a cache-busting version query parameter.
 * Replaces old link nodes with cloned nodes to force modern browsers to reload the icon.
 */
export function syncDomFavicon(version?: string | number): void {
  if (typeof document === 'undefined') return
  const v = version || Date.now()
  const links = document.querySelectorAll<HTMLLinkElement>(
    "link[rel*='icon'], link[rel='apple-touch-icon']",
  )
  links.forEach((link) => {
    const rawHref = link.getAttribute('href')
    if (!rawHref) return
    const basePath = rawHref.split('?')[0]
    const newHref = `${basePath}?v=${v}`

    const newLink = link.cloneNode(true) as HTMLLinkElement
    newLink.setAttribute('href', newHref)
    if (link.parentNode) {
      link.parentNode.replaceChild(newLink, link)
    }
  })
}
